module.exports = __webpack_public_path__ + "img/id_step_02_en@2x.5a4aa9f7.png";